<ag1-button
  variant="secondary"
  classOverrides="
        w-56
        bg-white!
      "
  [disabled]="disabled()"
  (clickEvent)="!disabled() && savedViewsMenu.toggle($event)"
>
  <svg-icon
    [class]="disabled() ? 'text-slate-400!' : 'text-steel-blue-500!'"
    src="/assets/icons/general/display-adjustments.svg"
  />
  <span class="overflow-hidden text-ellipsis whitespace-nowrap">
    {{ selectedViewName }}
  </span>
  <svg-icon class="ml-auto" src="/assets/icons/general/chevron-down.svg" />
</ag1-button>

<p-popover
  #savedViewsMenu
  (onHide)="resetFilteredViews()"
  (onShow)="trackViewOpenEvent()"
>
  <div class="flex max-w-140 flex-col gap-5 landscape:max-h-[50vh]">
    <!-- Title -->
    <p class="mr-6 whitespace-nowrap font-semibold">Saved views</p>

    <ng-container
      *ngTemplateOutlet="
        viewConfigurations?.length ? savedViewsTemplate : noSavedViewsTemplate
      "
    />

    <!-- Close Menu -->
    <p-button
      variant="text"
      severity="contrast"
      size="small"
      pTooltip="Close"
      tooltipPosition="left"
      class="absolute right-1 top-2"
      (click)="closeSavedViewsMenu()"
    >
      <ng-template #icon>
        <svg-icon src="/assets/icons/general/close.svg" />
      </ng-template>
    </p-button>
  </div>
</p-popover>

<ng-template #noSavedViewsTemplate>
  <div class="flex max-w-82 flex-col place-items-center gap-5">
    <p class="text-wrap text-center">
      You haven't saved any views yet. Use the button below to save your current
      view.
    </p>

    <p-button label="Save a view" (click)="onSaveAView()" />
  </div>
</ng-template>

<ng-template #savedViewsTemplate>
  <!-- View Search -->
  <ag1-list-search
    [keys]="['displayName']"
    [items]="viewConfigurations"
    placeholder="Search Views"
    (filteredItemEvent)="filteredViews = $event"
  />

  <div
    class="grid max-h-64 min-w-[24rem] grid-cols-1 gap-5 overflow-y-auto overflow-x-hidden px-1.5"
  >
    <!-- default option -->
    <div
      class="group flex items-center gap-3 rounded px-3 py-2 hover:bg-slate-50"
    >
      <input
        [checked]="defaultState"
        type="radio"
        name="views"
        id="default"
        (click)="viewReset()"
        value="default"
        [(ngModel)]="selectedViewId"
      />
      <label
        for="default"
        class="select-none overflow-hidden text-ellipsis whitespace-nowrap"
        >AgrigateOne Default</label
      >
    </div>

    <!-- Radio Group -->
    @for (viewConfig of filteredViews; track viewConfig) {
      <ng-container
        *ngTemplateOutlet="savedViews; context: { view: viewConfig }"
      />
    }
  </div>

  <!-- Save View -->
  <p-button
    variant="text"
    severity="contrast"
    label="Save a new view"
    (click)="viewCreate()"
  >
    <svg-icon src="/assets/icons/general/plus.svg" />
  </p-button>
</ng-template>

<!-- Radio Button view selector-->
<ng-template #savedViews let-view="view">
  <div
    class="group flex items-center gap-3 rounded px-3 py-2 hover:bg-slate-50"
  >
    <input
      type="radio"
      name="views"
      [id]="view.id"
      (click)="viewSelect(view)"
      [value]="view.id"
      [(ngModel)]="selectedViewId"
    />
    <label
      [for]="view.id"
      class="select-none overflow-hidden text-ellipsis whitespace-nowrap"
      >{{ view.displayName }}</label
    >
    <div class="invisible ml-auto flex items-center gap-1 group-hover:visible">
      <p-button
        size="small"
        tooltipPosition="left"
        severity="secondary"
        pTooltip="Edit"
        (click)="viewUpdate(view)"
      >
        <ng-template #icon>
          <svg-icon src="/assets/icons/general/edit.svg" />
        </ng-template>
      </p-button>

      <p-button
        size="small"
        tooltipPosition="left"
        severity="secondary"
        pTooltip="Delete"
        (click)="viewDelete(view)"
      >
        <ng-template #icon>
          <svg-icon src="/assets/icons/general/remove.svg" />
        </ng-template>
      </p-button>
    </div>
  </div>
</ng-template>

<!-- View visibility options -->
<ng-template #viewVisibilityCustomOptions let-item>
  <div class="flex items-center gap-3 rounded-lg p-3">
    <svg-icon [src]="item.icon" class="shrink-0 text-steel-blue-500" />
    <div class="grid grid-cols-1 gap-1">
      <h1 class="text-base text-slate-800">{{ item.heading }}</h1>
      <span class="text-sm text-slate-500">{{ item.description }}</span>
    </div>
  </div>
</ng-template>

<!-- View visibility label -->
<ng-template #viewVisibilityCustomLabels let-item>
  <div class="flex items-center gap-3">
    <svg-icon [src]="item.icon" class="shrink-0 text-steel-blue-500" />
    <span>{{ item.heading }}</span>
  </div>
</ng-template>
